<div class="row-marker-container" [style.background-color]="data.color">
  <span class="row-marker">{{ data.rowNumber }}</span>
</div>
